import React from 'react';
import WindowedSelect from 'react-windowed-select';
import { ClipLoader } from 'react-spinners';
import { fmt3 } from './saleVoucherHelpers';
import { PARTY_TYPES } from './saleVoucherConstants';
import { Field, selectProps } from './formParts';

/** Party radios, "From Chart of Accounts", the debit select and the read-only party detail. */
const PartyPanel = ({
    form, disabled, error, partyOptions, partyLoading, detail, detailLoading, detailMessage, warning,
    onPartyType, onUseCoa, onCustomer, trailing,
}) => (
    <>
        <div className="d-flex align-items-center flex-wrap" style={{ columnGap: 28, rowGap: 8 }}>
            {PARTY_TYPES.map((type) => (
                <div className="form-check m-0 d-flex align-items-center gap-2" key={type}>
                    <input
                        type="radio" className="form-check-input m-0" name="partyType" id={`party${type}`}
                        checked={form.partyType === type} disabled={disabled} onChange={() => onPartyType(type)}
                    />
                    <label className="form-check-label" htmlFor={`party${type}`}>{type}</label>
                </div>
            ))}
            <div className="form-check m-0 d-flex align-items-center gap-2">
                <input
                    type="checkbox" className="form-check-input m-0" id="partyCoa"
                    checked={form.useCoa} disabled={disabled} onChange={(e) => onUseCoa(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="partyCoa">From Chart of Accounts</label>
            </div>
            {(partyLoading || detailLoading) && (
                <div className="d-flex align-items-center gap-2 text-muted small" role="status" aria-live="polite">
                    <ClipLoader size={18} color="#6c5ce7" />
                    <span>{partyLoading ? 'Loading debit accounts…' : 'Loading party details…'}</span>
                </div>
            )}
            {trailing}
        </div>

        <Field label="Debit Account" required error={error}>
            <WindowedSelect
                {...selectProps}
                isLoading={partyLoading}
                isDisabled={disabled}
                placeholder="--Select--"
                value={form.customer}
                options={partyOptions}
                onChange={(o) => onCustomer(o || null)}
                isClearable
            />
            {warning && <div className="text-warning small mt-1">{warning}</div>}
        </Field>

        <Field label="Party Details">
            <div className="p-2 form-control" style={{ background: '#e9ecef', minHeight: 38 }}>
                {detailLoading && <ClipLoader size={14} color="#6c5ce7" />}
                {!detailLoading && detailMessage && <span className="text-danger">{detailMessage}</span>}
                {!detailLoading && !detailMessage && detail && (
                    <div className="small">
                        <div className="fw-semibold">{detail.customerName}</div>
                        <div>{detail.address1}</div>
                        <div>{detail.address2 || detail.cityCountry}</div>
                        <div>Contact: {detail.contactNo || '---'} · VAT Reg: {detail.vatRegNo || '---'}</div>
                        <div className="fw-bold mt-1">Balance: {fmt3(detail.balance)}</div>
                    </div>
                )}
                {!detailLoading && !detailMessage && !detail && <span className="text-muted">---</span>}
            </div>
        </Field>
    </>
);

export default PartyPanel;
